// extracted by mini-css-extract-plugin
export default {"wrapper":"payment-option_wrapper__Kq3bO","title":"payment-option_title__RHMAT"};